export default __webpack_public_path__ + "static/media/al-seal.b9c9f820.png";